<template>
  <div>
    <div class="website-pc">
      <swiper class="swiper-no-swiping" :options="swiperOption">
        <swiper-slide class="banner">
          <div class="banner-main">
            <div class="main-header">
              <div class="header-left">
                <div>
                  <h2>联系我们</h2>
                  <p>CONTACT US</p>
                  <div class="line"></div>
                </div>
              </div>
              <div class="header-right">
                <div class="logo-right">
                  <img src="../assets/images/Contact-logo.png" alt />
                  <p>北京法苗网络科技有限公司</p>
                </div>
                <ul>
                  <li>
                    <img src="../assets/images/address-icon.png" alt />
                    <p>公司地址：深圳市南山区讯美科技广场3号楼1105室</p>
                  </li>
                  <li>
                    <img src="../assets/images/email-icon.png" alt />
                    <p>电子邮箱：kf@famiaowang.com</p>
                  </li>
                  <li>
                    <img src="../assets/images/telephone-icon.png" alt />
                    <p>服务热线：4008-222-778</p>
                  </li>
                </ul>
              </div>
            </div>
            <div class="main-footer">
              <div class="footer-header">
                <p>乘坐地铁：深圳一号线至深大地铁站A4出口</p>
                <p>乘坐公交：81路、专92路、专120路等…科苑北站下车</p>
              </div>
              <div id="allmap" style="width:1000px;height:340px;margin:auto;margin-top:10px"></div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div class="website-mobile">
      <swiper class="swiper-no-swiping" :options="swiperOption">
        <swiper-slide class="banner">
          <div class="banner-main">
            <div class="about-header">
              <h2>联系我们</h2>
              <p>CONTACT US</p>
            </div>
            <div class="about-text">
              <div class="text-main">
                <img style="height:70px" src="../assets/images/联系我们logo@2x.png" alt />
                <p class="comName">北京法苗网络科技有限公司</p>
                <div class="line-border"></div>
                <ul class="text-ul">
                  <li>
                    <img src="../assets/images/公司地址@2x.png" alt />
                    <div style="margin-left:10px">
                      <p class="p-title">公司地址</p>
                      <p class="p-text">深圳市南山区讯美科技广场3号楼1105室</p>
                    </div>
                  </li>
                  <li>
                    <img src="../assets/images/电子邮箱@2x.png" alt />
                    <div style="margin-left:10px">
                      <p class="p-title">电子邮箱</p>
                      <p class="p-text">kf@famiaowang.com</p>
                    </div>
                  </li>
                  <li>
                    <img src="../assets/images/服务热线@2x.png" alt />
                    <div style="margin-left:10px">
                      <p class="p-title">服务热线</p>
                      <p class="p-text">4008-222-778</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="about-footer">
              <div class="footer-main">
                <ul class="footer-ul">
                  <li>
                    <p class="p-title">乘坐地铁</p>
                    <p class="p-text">深圳一号线至深大地铁站A4出口</p>
                  </li>
                  <li>
                    <p class="p-title">乘坐公交</p>
                    <p class="p-text">81路、专92路、等…科苑北站下车</p>
                  </li>
                </ul>
                <div class="footer-border"></div>
                <div style="width:100%;height:300px;margin-top:20px">
                  <div id="mapMobile" ref="mapMobile" style="width:100%;height:100%;"></div>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact",
  data() {
    return {
      swiperOption: {
        preloadImages: false,
        direction: "vertical", //垂直方向移动
        autoHeight: true //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
      }
    };
  },
  mounted() {
    this.baiduMap();
    this.baiduMapMobile();
  },
  methods: {
    baiduMapMobile: function() {
      // 百度地图API功能
      var map = new BMap.Map(this.$refs.mapMobile);
      map.centerAndZoom(new BMap.Point(113.952756, 22.551459), 18);
      map.enableScrollWheelZoom(true);
      this.theLocation(map);
    },
    baiduMap: function() {
      // 百度地图API功能
      var map = new BMap.Map("allmap");
      map.centerAndZoom(new BMap.Point(113.952756, 22.551459), 18);
      map.enableScrollWheelZoom(true);
      this.theLocation(map);
    },
    // 用经纬度设置地图中心点
    theLocation: function(map) {
      map.clearOverlays();
      var new_point = new BMap.Point(113.952756, 22.551459);
      var marker = new BMap.Marker(new_point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      map.panTo(new_point);
      var opts = {
        position: new_point, // 指定文本标注所在的地理位置
        offset: new BMap.Size(-110, -80) //设置文本偏移量
      };
      var label = new BMap.Label("深圳市南山区讯美科技广场", opts); // 创建文本标注对象
      label.setStyle({
        color: "#000",
        fontSize: "16px",
        background: "#ccc",
        lineHeight: "20px",
        fontWeight: "bold",
        border: "none",
        padding: "10px",
        width: "200px",
        textAlign: "center",
        fontFamily: "微软雅黑",
        borderRadius: "5px"
      });
      map.addOverlay(label);

      var circle = new BMap.Circle(new_point, 70, {
        strokeColor: "blue",
        strokeWeight: 2,
        strokeOpacity: 0.4
      }); //创建圆
      map.addOverlay(circle);
      var top_right_navigation = new BMap.NavigationControl({
        anchor: BMAP_ANCHOR_TOP_RIGHT,
        type: BMAP_NAVIGATION_CONTROL_SMALL
      }); //右上角
      map.addControl(top_right_navigation);
    }
  }
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 751px) {
  .website-mobile {
    display: none;
  }

  .banner {
    background: url('../assets/images/backTu.jpg') no-repeat center center;
    background-size: cover;

    .banner-main {
      width: 1100px;
      height: 677px;
      margin: auto;
      margin-top: 120px;
      margin-bottom: 100px;

      border-radius: 8px;

      .main-header {
        display: flex;

        width: 1060px;
        height: 220px;
        margin: auto;
        padding: 20px;

        border-radius: 8px;
        background: #fff;

        .header-left {
          width: 380px;
          margin-left: 40px;

          border-right: 1px solid rgba(204, 204, 204, .9);
          background: #fff;

          h2 {
            font-family: SourceHanSansCN-Bold;
            font-size: 30px;
            font-weight: bold;

            padding-top: 20px;

            letter-spacing: 0;

            color: #000;
          }

          p {
            font-family: SourceHanSansCN-Normal;
            font-size: 16px;
            font-weight: 540;

            margin-top: 10px;

            letter-spacing: 0;

            color: #000;
          }

          .line {
            width: 70px;
            height: 10px;
            margin-top: 80px;

            border-radius: 2px;
            border-radius: 2px;
            background: yellow;
            background: #fec030;
          }
        }

        .header-right {
          width: 650px;
          margin-left: 100px;

          .logo-right {
            display: flex;

            height: 60px;
            margin-bottom: 10px;
            margin-left: 20px;

            p {
              font-family: SourceHanSansCN-Medium;
              font-size: 30px;
              line-height: 60px;

              margin-left: 10px;

              letter-spacing: 0;

              color: #333;
            }
          }

          ul {
            padding: 0 20px;

            li {
              font-family: Source Han Sans CN;
              font-size: 16px;

              display: flex;

              height: 40px;
              margin-bottom: 10px;

              letter-spacing: 0;

              color: #333;

              p {
                font-weight: 550;
                line-height: 50px;

                margin-left: 10px;
              }

              img {
                width: 30px;
                height: 30px;
                margin-top: 10px;
              }
            }
          }
        }
      }

      .main-footer {
        width: 1060px;
        height: 400px;
        margin: auto;
        margin-top: 20px;
        padding: 20px;

        border-radius: 8px;
        background: #fff;

        .footer-header {
          display: flex;

          width: 1000px;
          height: 50px;
          margin: auto;

          border-bottom: 1px solid #ccc;

          p {
            font-family: SourceHanSansCN-Medium;
            font-size: 16px;
            line-height: 50px;

            width: 500px;

            letter-spacing: 0;

            color: #333;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .website-pc {
    display: none;
  }

  .banner {
    background: url('../assets/images/联系我们bg.png') no-repeat center center;
    background-size: cover;

    .banner-main {
      width: 90%;
      margin: auto;

      .about-header {
        width: 200px;
        height: 60px;
        margin-top: 40px;

        color: #fff;

        h2 {
          font-family: SourceHanSansCN-Bold;
          font-size: 24px;
          font-weight: bold;

          letter-spacing: 2px;
        }

        p {
          font-family: SourceHanSansCN-Normal;
          font-size: 16px;

          margin-top: 14px;

          letter-spacing: 0;
        }
      }

      .about-text {
        width: 100%;
        margin-top: 20px;
        padding: 30px 0;

        border-radius: 4px;
        background: rgba(255, 255, 255, .9);

        .text-main {
          width: 90%;
          height: 340px;
          margin: auto;

          // background: red;

          .comName {
            font-family: SourceHanSansCN-Medium;
            font-size: 22px;

            margin-top: 20px;

            letter-spacing: 0;

            color: #333;
          }

          .line-border {
            width: 100%;
            margin-top: 20px;

            border-bottom: 1px solid rgba(0, 0, 0, .2);
          }

          .text-ul {
            margin-top: 20px;

            // background: pink;

            li {
              display: flex;
              align-items: center;

              height: 60px;
              margin-bottom: 10px;

              // background: red;
              img {
                height: 22px;
              }

              .p-title {
                font-family: SourceHanSansCN-Regular;
                font-size: 16px;

                letter-spacing: 0;

                color: #666;
              }

              .p-text {
                font-family: SourceHanSansCN-Bold;
                font-size: 18px;
                font-weight: bold;

                margin-top: 6px;

                letter-spacing: 0;

                color: #333;
              }
            }
          }
        }
      }

      .about-footer {
        width: 100%;
        height: 100%;
        margin: 20px 0;
        padding: 30px 0;

        border-radius: 4px;
        background: #fff;

        .footer-main {
          width: 90%;
          margin: auto;

          .footer-ul {
            li {
              height: 60px;
              margin-bottom: 10px;

              .p-title {
                font-family: SourceHanSansCN-Regular;
                font-size: 16px;

                letter-spacing: 0;

                color: #666;
              }

              .p-text {
                font-family: SourceHanSansCN-Bold;
                font-size: 16px;
                font-weight: bold;

                margin-top: 8px;

                letter-spacing: 0;

                color: #333;
              }
            }
          }

          .footer-border {
            width: 100%;

            border-bottom: 1px solid rgba(0, 0, 0, .2);
          }
        }
      }
    }
  }
}













































</style>
